var THEME_MAP = {}; // 主题映射
/**
 * 获取对应的主题
 * @param type
 */
export var getTheme = function (type) {
    return THEME_MAP[type.toLowerCase()];
};
/**
 * 注册主题
 * @param type
 * @param theme
 */
export var registerTheme = function (type, theme) {
    if (getTheme(type)) {
        throw new Error("Theme type '" + type + "' existed.");
    }
    THEME_MAP[type.toLowerCase()] = theme;
};
//# sourceMappingURL=factory.js.map